import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ServicesService } from '../services.service';
import { Observable } from 'rxjs/Observable';
import { DataSource } from '@angular/cdk/collections';
import { User } from '../models/fileCode.model';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {HttpErrorResponse} from '@angular/common/http';
import {Router} from '@angular/router';


@Component({
  selector: 'app-myorders',
  templateUrl: './myorders.component.html',
  styleUrls: ['./myorders.component.css']
})
export class MyordersComponent implements OnInit, AfterViewInit {

    dataSource       = new MatTableDataSource();
    displayedColumns = ['order_number', 'date', 'amount', 'status', 'action'];
    header           = 'l-header';
    navbar           = 'l-navbar l-navbar_t-light l-navbar_expand js-navbar-sticky';
    constructor(private _services: ServicesService , private router: Router) {   }

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

  ngOnInit() {
      // this.dataSource.data =[];
      this.disableBack();
      this.getOrder();
  }

    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }

    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
        this.dataSource.filter = filterValue;
    }

    public getOrder() {
        const userData = JSON.parse(localStorage.getItem('userData'));
        const token = localStorage.getItem('userToken');
        // userData.hasOwnProperty('id')
        const user_id = userData ? userData.id : '';
        this._services.getOrder({'token': token}).subscribe((data: any) => {
                $('.tb-preloader-wave').fadeOut();
                $('#tb-preloader').delay(200).fadeOut('slow').remove();
                if (data.status === 200) {
                    // console.log(data.result)
                    this.dataSource.data = data.result;
                    // this.dataSource = new MyDataSource();
                }else {
                    this.dataSource.data = [];
                    // this.router.navigate(['login']);
                }
            },
            (err: HttpErrorResponse) => {

            });
    }

    public disableBack() { window.history.forward(); }

    // window.onload = disableBack();
    // window.onpageshow = function(evt) { if (evt.persisted) disableBack() }

}



// WEBPACK FOOTER //
// /var/www/html/oneills-web-qa/src/app/myorders/myorders.component.ts